import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion, AccordionSummary, Box } from "@mui/material";
import { ChevronDown } from "mdi-material-ui";
import { useTranslation } from "react-i18next";
import { interpolate, markdownToHtmlSync } from "./index.js";
export const useQuestions = (tag) => {
    // @ts-ignore
    const { i18n } = useTranslation();
    return (i18n.store.data[i18n.language.replace("-", "")]
        ?.Questions || []).filter(({ tags }) => tags?.includes(tag));
};
export function Questions({ questions, values, children, ...props }) {
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { marginTop: 5 }, ...props, children: questions.map(({ title, content }) => (_jsxs(Accordion, { disableGutters: true, variant: "outlined", sx: {
                        backgroundColor: "transparent",
                        borderTopWidth: 0,
                        "&:first-of-type": {
                            borderTopWidth: 1,
                        },
                        "&:before": {
                            display: "none",
                        },
                    }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ChevronDown, {}), children: _jsx(Box, { sx: { typography: "body2", "& > p": { m: 0 } }, dangerouslySetInnerHTML: {
                                    __html: markdownToHtmlSync(title).value.toString(),
                                } }) }), _jsx(Box, { sx: { mt: -1, mx: 2, typography: "body2" }, dangerouslySetInnerHTML: {
                                __html: markdownToHtmlSync(values ? interpolate(content, values) : content).value.toString(),
                            } })] }, title))) }), children] }));
}
//# sourceMappingURL=Questions.js.map